import { Element as RustigElement } from 'rustig';

export class HideIfHasValue {
  public static wireup() {
    $(document).on('change', '[data-hide-target-if-has-value]', function (e: Event) {
      let target = e.target as HTMLElement;
      let key = target.getAttribute('data-hide-target-if-has-value');
      let element = document.querySelector('hide-if-has-value-target'.asDataSelector(key));

      let specificValue = element.getAttribute("data-specific-value");
      if (specificValue)
        $(element).toggleShow(RustigElement.from(target).value() != specificValue);
      else
        $(element).toggleShow(!RustigElement.from(target).value());
    });
  }
}